import React, { useEffect } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import NavigationSidebar from '../components/Navigation/NavigationSidebar';
import MobileDrawerToggle from '../components/Navigation/MobileDrawer';
import { useNavigation } from '../components/Navigation/NavigationContext';

const DashboardLayout: React.FC = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { sidebarOpen, toggleSidebar, setSidebarOpen } = useNavigation();

  useEffect(() => {
    if (mobile) setSidebarOpen(false);
  }, [mobile, setSidebarOpen]);
  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh', minWidth: 0, bgcolor: 'background.default' }}>
      <NavigationSidebar open={sidebarOpen} onToggle={toggleSidebar} />
      <MobileDrawerToggle />
      <Box component="main" sx={{ flex: 1, minWidth: 0, bgcolor: 'background.default' }}>
        <Box component="header" sx={{ display: 'flex', alignItems: 'center', height: 56, px: { xs: 2, md: 3 }, pl: { xs: 8, md: 3 }, bgcolor: '#fff', borderBottom: '1px solid #dedbd7' }}>
          <Typography sx={{ color: '#272522', fontSize: 12, fontWeight: 700 }}>マイシフト</Typography>
        </Box>
        <Box sx={{ width: '100%', maxWidth: 1600, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 4 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
